import axios from "axios";
import { API_URL } from "./constant";
import { dataDecrypt } from "./cryption";
import { clearAll, getItem } from "./localStorage";
import { notification } from "antd";
const axiosApi = axios.create({
  baseURL: API_URL,
});

const urlSite = window.location.href;

const token = getItem("HOQ_Token");

axiosApi.defaults.headers.common["Authorization"] = "Bearer " + token || "";

axiosApi.interceptors.response.use(
  (response) => {
    if (response.data.meta.code === 302) {
      localStorage.clear();
      // window.location.replace("/signin");
    } else {
      return response.data;
    }
  },
  (error) => {
    console.log("error", error);
    if (error.code === "ERR_NETWORK") {
      notification.error({
        message: "Error",
        description: error?.message || "Something went wrong",
      });
    }
    if (error.code === "ERR_BAD_REQUEST") {
      notification.error({
        message: "Error",
        description:
          error?.response?.data?.meta?.message || "Something went wrong",
      });
    }
    const isAuthorized = error?.response?.code === 302;
    if (isAuthorized) {
      clearAll();
      // window.location.href = "/signin";
    }
    return error.response.data;
  },
);
const makeRequest = (method, url, config = {}) => {
  let requestConfig = {
    ...config,
    method,
    url,
  };
  return axiosApi(requestConfig);
};
export const get = (url, config = {}) => makeRequest("get", url, config);
export const post = (url, config = {}) => makeRequest("post", url, config);
export const patch = (url, config = {}) => makeRequest("patch", url, config);
export const del = (url, config = {}) => makeRequest("delete", url, config);
